import React from 'react'

function ActivateCalendarImage() {
    return (
        // eslint-disable-next-line jsx-a11y/img-redundant-alt
        <img
          src="/scheduling2.webp"
          alt="advanced to english background image"
          className="w-full object-cover"
          sizes="100vw"
          width={0}
          height={0}
          style={{ width: "100%", height: "100%" }}
        />
      );
}

export default ActivateCalendarImage
